import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environment/environment';
var DocumentsService = /** @class */ (function () {
    function DocumentsService(httpClient) {
        this.httpClient = httpClient;
        this.apiBase = environment.API_BASE + '/api/documents/';
    }
    /**
     * Get list of expiring documents
     * @method getDocuments
     */
    DocumentsService.prototype.getDocuments = function (documentsReqBody) {
        var params = new HttpParams();
        if (documentsReqBody) {
            var reqBodyEntries = Object.entries(documentsReqBody);
            reqBodyEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(this.apiBase, { params: params });
    };
    /**
     * Toggle notification about document expiry
     * @method toggleNotification
     */
    DocumentsService.prototype.toggleNotification = function (documentId, showAlert) {
        var url = "" + this.apiBase + documentId + "/";
        return this.httpClient.patch(url, { showExpiryAlerts: showAlert });
    };
    /**
     * Get list of authenticites
     * @method getAuthenticites
     */
    DocumentsService.prototype.getAuthenticites = function () {
        var url = this.apiBase + "authenticities/";
        return this.httpClient.get(url);
    };
    /**
     * Get list of document types
     * @method getDocumentTypes
     */
    DocumentsService.prototype.getDocumentTypes = function (recordType) {
        var url = this.apiBase + "document_types/?filter=" + recordType;
        return this.httpClient.get(url);
    };
    DocumentsService.prototype.createRecordDocument = function (payload) {
        var form = new FormData();
        if (payload.document) {
            form.append('document', payload.document);
        }
        if (payload.backDocument) {
            form.append('back_document', payload.backDocument);
        }
        if (payload.documentNumber) {
            form.append('document_number', payload.documentNumber);
        }
        if (payload.authenticity) {
            form.append('authenticity', payload.authenticity);
        }
        if (payload.docType) {
            form.append('doc_type', payload.docType);
        }
        if (payload.docTypeCategory) {
            form.append('doc_type_category', payload.docTypeCategory);
        }
        if (payload.issueDate) {
            form.append('issue_date', payload.issueDate);
        }
        if (payload.expiryDate) {
            form.append('expiry_date', payload.expiryDate);
        }
        if (payload.showExpiryAlerts != null) {
            form.append('show_expiry_alerts', String(payload.showExpiryAlerts));
        }
        return this.httpClient.post(environment.API_BASE + "/api/records/" + payload.recordId + "/documents/", form);
    };
    DocumentsService.prototype.updateRecordDocument = function (payload) {
        var form = new FormData();
        if (payload.document) {
            form.append('document', payload.document);
        }
        if (payload.backDocument) {
            form.append('back_document', payload.backDocument);
        }
        else if (payload.backDocument === null) {
            form.append('back_document', '');
        }
        if (payload.documentNumber) {
            form.append('document_number', payload.documentNumber);
        }
        if (payload.authenticity) {
            form.append('authenticity', payload.authenticity);
        }
        if (payload.docType) {
            form.append('doc_type', payload.docType);
        }
        if (payload.docTypeCategory) {
            form.append('doc_type_category', payload.docTypeCategory);
        }
        if (payload.issueDate) {
            form.append('issue_date', payload.issueDate);
        }
        if (payload.expiryDate) {
            form.append('expiry_date', payload.expiryDate);
        }
        if (payload.showExpiryAlerts != null) {
            form.append('show_expiry_alerts', String(payload.showExpiryAlerts));
        }
        return this.httpClient.patch(environment.API_BASE + "/api/documents/" + payload.id + "/", form);
    };
    DocumentsService.prototype.deleteDocument = function (documentId) {
        return this.httpClient.delete("" + this.apiBase + documentId + "/");
    };
    return DocumentsService;
}());
export { DocumentsService };
